export default {
  供应商绩效管理: "Supplier Performance Management",
  删除成功: "Deleted successfully!",
  确认操作: "Confirm Action",
  "删除记录后不可恢复，你确定要执行此操作吗？":
    "Deleted records cannot be recovered. Are you sure you want to proceed?",
  发起考核: "Initiate Assessment",
  考核维度: "Assessment Dimension",
  考核项: "Assessment Item",
  "差 (25分)": "Poor (25 points)",
  "一般 (50分)": "Fair (50 points)",
  "良好 (75分)": "Good (75 points)",
  "优秀 (100分)": "Excellent (100 points)",
  创建成功: "Created successfully",
  填写成功: "Submitted successfully!",
  "提交后表单将无法修改，您确定要提交吗？":
    "The form cannot be modified after submission. Are you sure you want to submit?",
  供应商绩效考核评估通过: "Supplier Performance Assessment Approved",
  评估成功: "Assessment successful",
  请完成我的评价: "Please complete your evaluation",
  请选择考核人: "Please select an evaluator",
  供应商绩效考核评分表: "Supplier Performance Assessment Form",
  我的评分: "My Score",
  评分邀请: "Assessment Invitation",
  供应商基本信息: "Basic Supplier Information",
  供应商id: "Supplier ID",
  供应商编号: "Supplier Code",
  请输入供应商编号: "Enter supplier code",
  供应商名称: "Supplier Name",
  请输入供应商名称: "Enter supplier name",
  采购金额: "Purchase Amount",
  请选择采购金额: "Select purchase amount",
  供应风险: "Supply Risk",
  请选择供应风险: "Select supply risk",
  供应商类别: "Supplier Category",
  请选择供应商类别: "Select supplier category",
  供应商改进和激励举措: "Supplier Improvement and Incentive Measures",
  请填写供应商改进和激励举措:
    "Enter supplier improvement and incentive measures",
  供应商绩效评分: "Supplier Performance Score",
  评估人: "Evaluator",
  得分: "Score",
  "考核得分：": "Assessment Score:",
  "绩效级别：": "Performance Level:",
  无需邀请其他考核人: "No additional evaluators needed",
  "考核部门：": "Department:",
  "考核人：": "Evaluator:",
  供应商阶段: "Supplier Stage",
  已评估: "Assessed",
  评估中: "In Progress",
  考核得分: "Assessment Score",
  绩效级别: "Performance Level",
  考核状态: "Assessment Status",
  创建人: "Created By",
  考核发起人: "Assessment Initiator",
  发起时间: "Initiation Time",
  分: "points",
};
